import { r2Fetch } from './client';

export interface R2FileCreateParams {
  bucket_id: string;
  directory_name: string;
  file_name: string;
  content?: string;
  metadata?: Record<string, string>;
}

export interface R2FileCreateResponse {
  success: boolean;
}

export async function r2FileCreate(
  params: R2FileCreateParams
): Promise<R2FileCreateResponse> {
  return r2Fetch<R2FileCreateResponse>('/rpc/r2_file_create', {
    body: params,
  });
}
